import { render, staticRenderFns } from "./CreditLoanAndRepayRecord.vue?vue&type=template&id=55dade8c&scoped=true"
import script from "./CreditLoanAndRepayRecord.vue?vue&type=script&lang=js"
export * from "./CreditLoanAndRepayRecord.vue?vue&type=script&lang=js"
import style0 from "./CreditLoanAndRepayRecord.vue?vue&type=style&index=0&id=55dade8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dade8c",
  null
  
)

export default component.exports